import { Field, Label, Switch } from '@headlessui/react';
import classNames from 'classnames';

type ToggleProps = {
  value: boolean;
  onToggle: (boolean: boolean) => void;
  disabled?: boolean;
  className?: string;
  testId?: string;
  label?: {
    content: string;
    className?: string;
    side?: 'left' | 'right';
  };
};

export default function Toggle({
  value,
  onToggle,
  disabled = false,
  className,
  label,
  ...rest
}: ToggleProps) {
  return (
    <Field>
      <div className={classNames(Boolean(label) && 'flex items-center gap-x-2')} {...rest}>
        {label && (label.side === 'left' || label.side === undefined) && (
          <Label className={label.className}>{label.content}</Label>
        )}
        <Switch
          disabled={disabled}
          checked={value}
          onChange={onToggle}
          className={classNames(
            'group inline-flex h-[16px] w-[30px] rounded-full border-2 border-transparent bg-cf-gray-4 outline-none transition-colors duration-200 ease-in-out',
            className,
          )}
        >
          <span
            aria-hidden="true"
            className={classNames(
              'inline-block h-[12px] w-[12px] translate-x-0 transform rounded-full transition duration-200 ease-in-out',
              'group-data-[checked]:translate-x-[14px] group-data-[checked]:bg-cf-green-1 group-data-[checked]:shadow-[0px_0px_4px] group-data-[checked]:shadow-cf-green-1',
              'bg-cf-white group-disabled:bg-cf-light-1 group-disabled:shadow-cf-light-1',
              !value && 'group-hover:enabled:bg-cf-white',
            )}
          />
        </Switch>
        {label?.side === 'right' && <Label className={label.className}>{label.content}</Label>}
      </div>
    </Field>
  );
}
